// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"b1-z","subtitle":"c1-z","wrapper":"d1-z","leftArrow":"e1-z","rightArrow":"f1-z"};